export default __webpack_public_path__ + "static/media/function_black.4d1c915e.png";